import axiosSetup from "../utils/axiosSetup";
import toast from "react-hot-toast";

export const submitEmployeeDetailsApi = async (payload: any) => {
  try {
    const res = await axiosSetup.post("/employee-details", payload);
    return res.data.data;
  } catch (err: any) {
    console.error("Error submitting employee details:", err);
    toast.error(err?.response?.data?.message || "Failed to submit data");
    throw err;
  }
};

export const fetchEmployeeDetailsApi = async (userId: string) => {
  try {
    const res = await axiosSetup.get(
      `/employee-details/user-details?userId=${userId}`
    );
    return res.data.data;
  } catch (error: any) {
    toast.error(error?.response?.data?.message);
    throw error;
  }
};

export const updateEmployeeFieldApi = async ({
  userId,
  fieldKey,
  value,
}: {
  userId: string;
  fieldKey: string;
  value: any;
}) => {
  try {
    const res = await axiosSetup.patch("/employee-details/update-field", {
      userId,
      fieldKey,
      value,
    });
    return { fieldKey, value };
  } catch (err: any) {
    toast.error(err?.response?.data?.message || "Failed to update field");
    throw err;
  }
};
